import Response from '@/domain/response.entity';
import axios from 'axios';
import CalculationErrorFilter from '../entity/calculation-error-filter.entity';
import CalculationExecute from '../entity/calculation-execute.entity';
import CalculationResult from '../entity/calculation-result.entity';

export default class CalculationService {
  public static execute(businessUnitId: string, calculation: CalculationExecute) {
    return axios.post(`/api/v1/business-units/${businessUnitId}/calculations/execute`, calculation)
      .then((response: any) => CalculationResult.of(response.data))
  }

  public static confirm(businessUnitId: string, calculation: CalculationResult) {
    return axios.put(`/api/v1/business-units/${businessUnitId}/calculations/${calculation.id}/confirm`)
  }

  public static discard(businessUnitId: string, calculation: CalculationResult) {
    return axios.put(`/api/v1/business-units/${businessUnitId}/calculations/${calculation.id}/discard`)
  }

  public static simulate(
    businessUnitId: string,
    contractItemId: string,
    competence: String,
  ): Promise<string> {
    return axios
      .get(`/api/v1/business-units/${businessUnitId}/contract-items/${contractItemId}/simulate-billing/?competence=${competence}`)
      .then((response) => response.data);
  }

  public static simulateRetroactive(
    businessUnitId: string,
    contractItemId: string,
    competences: string,
    invoiceCompetence: string,
    startDate: string,
    endDate: string,
  ): Promise<string> {
    return axios
      .get(`/api/v1/business-units/${businessUnitId}/contract-items/${contractItemId}/simulate-retroactive-billing`, {
        params: {
          competences,
          invoiceCompetence,
          startDate,
          endDate,
        },
      }).then((response: any) => response.data);
  }

  public static getCalculationErrors(businessUnitId: string, filter: CalculationErrorFilter,
    page: number, size: number): Promise<Response> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/calculations/errors`, {
      params: {
        customerExternalId: filter.customerExternalId,
        customerId: filter.customerId,
        competence: filter.competence,
        date: filter.date,
        recentErrors: filter.recentErrors,
        page: page - 1,
        size,
      },
    }).then((resp: any) => Response.of(resp.data));
  }

  public static sendSimulationEmail(params: object): Promise<string> {
    return axios.post('/api/v1/business-units/contract-items/email-simulate-billing', params)
      .then((response: any) => response.data);
  }

  public static downloadFileSimulationBase64(params: object, downloadType: String): Promise<any> {
    return axios
      .post(`/api/v1/business-units/contract-items/download-simulate-billing-base64/${downloadType}`, params)
      .then((response: any) => response.data);
  }
}
